import { Product } from '@protos/product';
import { useApi } from '@shared/hooks/useApi';
import { createContext, useContext, useMemo } from 'react';
import { useAsync } from 'react-use';

type TradableProductSymbolsContextType = {
  allSymbols: string[];
  privateSymbols: string[];
  allProducts: Product[];
};

export const TradableProductSymbolsContext = createContext<TradableProductSymbolsContextType>({
  allSymbols: [],
  privateSymbols: [],
  allProducts: [],
});
TradableProductSymbolsContext.displayName = 'TradableProductSymbolsContext';

export default function TradableProductSymbolsContextProvider(props: any) {
  const { apiClient } = useApi();

  const state = useAsync(async () => {
    const products = await apiClient?.productsLoader({ tradable: true }).loadAllData();
    return {
      allSymbols: products?.map(product => product.symbol.toLowerCase()) || [],
      privateSymbols: products?.filter(product => product.private).map(product => product.symbol.toLowerCase()) || [],
      allProducts: products || [],
    };
  }, [apiClient]);

  return <TradableProductSymbolsContext.Provider value={state.value || { allSymbols: [], privateSymbols: [] }} {...props} />;
}

export function useTradableProductSymbolsContext(): TradableProductSymbolsContextType {
  const products = useContext(TradableProductSymbolsContext);
  return useMemo(() => products, [products]);
}
